import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import CardActions from '@material-ui/core/CardActions';
import IconButton from '@material-ui/core/IconButton';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import ps from '../../static/images/ps-logo.png';
import ai from '../../static/images/ai-logo.png';
import brium from '../../static/images/graphic-design/brium.jpg';
import fd from '../../static/images/graphic-design/Fathers-day-3.jpg';
import tic from '../../static/images/graphic-design/Friday-announcement-4.jpg';
import ile from '../../static/images/graphic-design/Ile_New-Logo_Web-02.jpg';
import mb from '../../static/images/graphic-design/right_logo-01.jpg';
import yb from '../../static/images/graphic-design/Youtube-banner-1.jpg';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        backgroundColor: theme.palette.background.paper,
    },
    gridList: {
        width: 500,
        padding: "20px",
        // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
        transform: 'translateZ(0)',
    },
    titleBar: {
        background:
            'linear-gradient(to top, rgba(0,0,0,0.7) 0%, ' +
            'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
    },
    icon: {
        color: 'white',
    },
    media: {
        height: 140,
    },
}));

const tileData = [
    {
        img: yb,
        title: 'YouTube Banner',
        author: 'author',
        featured: true,
        tool: ps,
        details: 'A Youtube banner for a church in the UK, designed with photoshop'
    },
    {
        img: mb,
        title: 'Branding',
        author: 'author',
        tool: ai,
        details: 'A logo concept and design for a gift delivery company in Nigeria'
    },
    {
        img: ile,
        title: 'Branding',
        author: 'author',
        tool: ai,
        details: 'A logo concept and design for a property listing web application in Nigeria'
    },
    {
        img: fd,
        title: 'IG Post',
        author: 'author',
        featured: true,
        tool: ai,
        details: `${"An IG post for Father's day designed for The Influencers Church, UK"}`
    },
    {
        img: tic,
        title: 'IG Post',
        author: 'author',
        tool: ps,
        details: 'An IG post for a church in the UK, designed with photoshop'
    },
    {
        img: brium,
        title: 'IG Post',
        author: 'author',
        tool: ai,
        details: 'An IG post for Brium, a delivery company in Abuja, Nigeria'
    },
];

export default function GraphicDesign() {
    const classes = useStyles();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("sm"));
    const sz = () => {
        if(!matches) {
            return 2;
        }

        return 1;
    }

    return (
        <div className={classes.root}>
            <GridList cellHeight={"auto"} spacing={1} className={classes.gridList}>
                {tileData.map((tile) => (
                    <GridListTile key={tile.img} cols={tile.featured ? 2 : sz()} rows={tile.featured ? 2 : sz()}>
                        <Box mt={3} p={1}>
                            <Card >
                                <CardActionArea>
                                    <CardMedia
                                        className={classes.media}
                                        image={tile.img}
                                        title={tile.title}
                                        component="img"
                                    />
                                    <CardContent>
                                        <Typography gutterBottom variant="h5" component="h2">
                                            {tile.title}
                                        </Typography>
                                        <Typography variant="body2" color="textSecondary" component="p">
                                            {tile.details}
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                                <CardActions>
                                    <IconButton aria-label="studio">
                                        <img src={tile.tool} width="25px" alt="Adobe Illustrator" />
                                    </IconButton>
                                </CardActions>
                            </Card>
                        </Box>
                    </GridListTile>
                ))}
            </GridList>
        </div>
    );
}